module.exports = __webpack_public_path__ + "static/media/new-icon.424343a3.svg";